'use strict';

var baseUtils = require('lyonscg/util/utils');

var utils = {
    getHost: function (href) {
        var l = document.createElement('a');
        l.href = href;
        return l.hostname;
    },
    /**
     * Disables Zoom on mobile
     */
    disableZoom: function () {
        $('head meta[name=viewport]').remove();
        $('head').prepend('<meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=0" />');
    },

    /**
    * Enables Zoom on mobile
    */
    enableZoom: function () {
        $('head meta[name=viewport]').remove();
        $('head').prepend('<meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=1" />');
    },
    /*
     * Trims text or returns empty string
     */
    trim: function (text) {
        return typeof (text) === 'string' ? text.trim() : '';
    }
};

module.exports = $.extend({}, baseUtils, utils);
